<template>
    <div style="margin:0 -12px;">
        <HeaderMenu></HeaderMenu>
        <div class="luna-header-box">
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <div style="padding:10px 0; overflow: hidden;" onclick="window.location.href = '/auth'">
                            <div class="item">
                                <svg style="height:36px;width:39px;fill:#5538EE;">
                                    <use xlink:href="/images/luna_logo.svg#luna_logo"></use>
                                </svg>
                            </div>
                            <div class="item">
                                <div class="logo" style="color: #5538EE;">Luna</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-2 text-center">
                        <a class="libere-header-menu" data-bs-toggle="offcanvas" href="#offcanvasRight"
                            aria-controls="offcanvasRight" style="outline: none;">
                            <div class="" style="color:#5538EE;padding-top:7px;">
                                <svg style="height:25px;width:25px;fill:#5538EE;">
                                    <use xlink:href="/images/menu.svg#menu"></use>
                                </svg>
                                <div class="text-nowrap" style="font-size: 8px;">
                                    メニュー
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrap" style="padding-top:56px;">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div style="padding:0 17px;">
                            <br>
                            <div style="font-weight: 600;font-size: 20px;line-height: 30px;">
                                縄の練習中だったからこそ、出会えたパートナー
                            </div>
                            <div style="color:#777;font-size:10px;border-bottom:1px solid #e6e6e6;padding:10px 0;">
                                2023年3月28日
                            </div>
                            <br>
                            <img src="/images/Group13340.png" class="img-fluid">
                            <div class="text-center"
                                style="color:#777;font-size:10px;border-bottom:1px solid #e6e6e6;padding:15px 0;">
                                ヒロユキさん・男性50代 埼玉<br />
                                りなさん・女性40代 茨木
                            </div>
                            <br>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaを始めたキッカケ</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span style="color:#6B4EFF">ヒロユキ</span>：当時まだ「SM」というものに足を踏み込み始めたばかりの頃でした。<br />
                                パートナーができたらいいなと考えていたら、ちょうどLunaがリリースしたんです。<br />
                                2022年の6月くらいだったと思います。<br />
                                その頃は、まだβ版で今ほど沢山の人も利用をしてませんでしたし、機能もあまり充実していませんでした。<br />
                                たまたまTwitterでLunaのツイートが流れてきて、面白そうだと思いβ版へ応募したんです。<br />
                                <br /><br />
                                <span style="color:#6B4EFF">リナ</span>：私は、ずっと誰かのところへ帰る場所がほしいなと思っていました。<br />
                                安心して誰かのところへ気持ちが帰ることが出来る、そんな場所がほしいと常々思っていました。<br />
                                「どんな関係の人がほしいんだろう。ただの友達や恋人とはまた違うものだなぁ」と思っていたところに、ちょうどLunaがリリースをしたんです。<br />
                                さっそくβ版で登録をしたら、当選をしてしまったので使い始めてみたのがキッカケでした。<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaは始めた頃どんな印象でしたか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span
                                    style="color:#6B4EFF">ヒロユキ</span>：Lunaは今までのマッチングサイトなどとは違い、SMに特化をしているので、SMに関して細かな所まで細分化をされており非常に面白いなと感じました。<br />
                                もともとSMの相手探しには掲示板を利用していたのですが、掲示板と比較してもかなり細かな情報を入力することができ、さらに検索も出来るので、<b>「これは相手が見つかりやすいな！」</b>と感じました。<br />
                                β版当時は送ることが出来るいいね数が無制限だったのもあり、気になる人には全員にいいね！を送っていました。
                                β版だったのもあったのかもしれませんが、押した人から結構ありがとうが返ってきて、「意外とマッチをするもんだな」と思ってました。<br />
                                <br /><br />
                                <span
                                    style="color:#6B4EFF">リナ</span>：ヒロユキさんと同じでSMの掲示板は使ったことがあったのですが、マッチングアプリ自体は今まで使ったことがありませんでした。<br />
                                いざ使ってみると、「こんなもんでいいねをもらえるのか！」 「こんな感じでいいねをするのか」っていう感じでした。<br />
                                Lunaは細かい情報を見ることが出来るし、話したい相手が見つかりそうだなと感じました。<br />
                                沢山のいいね！が来ていたのですが、私が縄をやっていたので、同じように縄をやっている人を選んでありがとうを返していました。<br />
                                その中で私が自分からいいね！を押したのは、ヒロユキさんだけでした。<br />
                                ヒロユキさんを見つけていいね！をしたのは、まだ縄を習っている最中だったからでした。<br />
                                もう自分の縄の形が完成をしてしまっている人は、私の好みに縄が育たないので、出来るのならまだ勉強中の人で、自分好みに縛り手を育てていきたいと考えてました。<br />
                                そんな中でヒロユキさんを見つけたんです。<br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>お相手とやり取りをしていてお相手はどのような印象でしたか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span style="color:#6B4EFF">リナ</span>：実はやり取り自体は大して多くないんです。<br />
                                縄をやっていることはお互いLunaのプロフィールで知っていたので、どこで習っているのかを聞いて早い段階から会う約束をしました。<br />
                                SM バーの縄の講習会で勉強をしていると聞いたので、そこで会おうという話になって、タイミングもあったので会うことになりました。<br />
                                <br /><br />
                                <span
                                    style="color:#6B4EFF">ヒロユキ</span>：そうですね、お互い会わないと分からないなとは思っていたので、会ったほうが手っ取り早いという話に早々になりましたね。<br />
                                <br />
                                <br />
                                <span
                                    style="color:#6B4EFF">リナ</span>：他の人ともやり取りはしていたのですが、他の人はすぐに二人きりで会おうと提案してきたのですが、ヒロユキさんだけは、最初はSMバーで会おうとしてくれて、それがとても安心に繋がったのを覚えています。<br />
                                そういう意味でも他の方とは違って、とても良い印象を持っていました。<br />
                                <br />
                                <img src="/images/report1.png" class="img-fluid">
                                <br />
                                <br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>会ったときのお相手の印象</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span
                                    style="color:#6B4EFF">ヒロユキ</span>：縄の講習を受けているSMバーで会っていることもあり、会ってすぐに縛ろうかという話になりました。<br />
                                縄で縛っているときもとても楽しそうに縛られてて、縛っている方としても嬉しくなりました。<br />
                                まだまだ練習中の拙い縄なのにも関わらず、楽しんでくれたことが嬉しく、出来るなら関係を続けたいなと感じたことを覚えてます。<br />
                                <br />
                                <br />
                                <span
                                    style="color:#6B4EFF">リナ</span>：楽しく縛っているのもだけれど、私は自分を見てほしい人なので、講師の方が教えていたり、縛っているときもヒロユキさんがしっかりと自分も見てくれていたのがとても嬉しく感じました。<br />
                                縄をしてるときも縄だけではなく、自分を見てくれるし、写真を取るときも常にどこかしらに触れて安心をさせてくれていた。そんな細かな心遣いにとても感心をして、とても安心しました。<br />
                                <br />
                                <img src="/images/report2.png" class="img-fluid">
                                <br />
                                <br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>現在はどのようなご関係なんですか？</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span style="color:#6B4EFF">二人</span>：パートナーとしての関係です。今後も二人でパートナーとしてやっていきたいと思っています。<br />
                                <br />
                                <br />
                                <span style="color:#6B4EFF">リナ</span>：私を責めてくれているヒロユキさんが楽しそうなので、ずっとこのまま一緒にいたいと思っています。<br />
                                <br />
                                <br />
                                <span style="color:#6B4EFF">ヒロユキ</span>：責めからの回復がとてもはやいんですよ。<br />
                                頑張っても体力が有り余ってるので、中々打ちひしがれなくて少しさみしいですが、それでも自分自身の伸びしろがあると思って楽しみです。<br />
                                今は縄が多いですが、今後は鞭などもやっていきたいと思っています。<br />
                                <br />
                                <img src="/images/report3.png" class="img-fluid">
                                <br />
                                <br />
                            </div>
                            <div style="font-size:18px;padding-bottom:15px;">
                                <b>Lunaを使われる方へ一言</b>
                            </div>
                            <div style="padding-bottom:80px;">
                                <span style="color:#6B4EFF">ヒロユキ</span>：Lunaは素敵なパートナーや色んな関係性の相手を見つけられます。<br />
                                焦らずじっくりと素敵な相手を見つけてもらいたいと思っています。<br />
                                <br /><br />
                                <span style="color:#6B4EFF">リナ</span>：女子はもらういいねには特に困らないと思うのですが、ただ文字だけだと分からないことも、すごく多いと思います。
                                そういう意味では、会ってみないとわからないこともあると思います。
                                もちろん誰でも気軽に会うというわけではないですが、しっかりと見極めて、まずはキッカケとして会ってみて、そして最後には良い人と巡り合ってほしいなと思っています。<br />
                            </div>
                            <br>
                            <br>
                            <br>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import HeaderMenu from './../HeaderMenu.vue'
import Footer from './../FooterLogin.vue'

export default {
    data() {
        return {
        };
    },
    components: {
        HeaderMenu: HeaderMenu,
        Footer: Footer,
    }
}

</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=MuseoModerno:wght@500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Alegreya+Sans+SC:wght@700&display=swap');

a {
    color: #6B4EFF;
    text-decoration:none;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    height: 56px;
    width: 540px;
    top: 0;
    background-color: #fff;
    z-index: 999;
}

@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}


.item {
    float: left;
}

.logo {
    font-size: 30px;
    line-height: 30px;
    padding-top: 5px;
    padding-left: 5px;
}

.login-box {
    width: 100%;
    border-radius: 20px;
    background-color: #fff;
    padding: 25px;
}

.item_box {
    padding: 30px 25px;
    background: #FFFFFF;
    border-radius: 10px;
}
</style>
